<script lang="ts" setup>
  import { computed } from 'vue';
  import { useShared } from '@othercommerce/foundation';

  interface HasPriceWithOmnibus {
    regularGross: string | null;
    regularNet: string | null;
    priceGross: string | null;
    priceNet: string | null;
    omnibusGross: string | null;
    omnibusNet: string | null;
  }

  interface Props {
    price: HasPriceWithOmnibus;
  }

  const props = defineProps<Props>();
  const shared = useShared();

  const regular = computed(() => {
    if (shared.value.includeVat) {
      return props.price.regularGross;
    } else {
      return props.price.regularNet;
    }
  });

  const price = computed(() => {
    if (shared.value.includeVat) {
      return props.price.priceGross;
    } else {
      return props.price.priceNet;
    }
  });

  const omnibus = computed(() => {
    if (shared.value.includeVat) {
      return props.price.omnibusGross;
    } else {
      return props.price.omnibusNet;
    }
  });

  const promotion = computed(() => {
    if (price.value !== null && regular.value !== null) {
      return price.value != regular.value;
    }

    return false;
  });
</script>
<template>
  <div v-if="promotion" class="omnibus">
    <template v-if="omnibus">
      {{ $t('SHOP.COMMON.LABEL.OMNIBUS') }}
      <SfMoney :value="omnibus" />
    </template>
    <template v-else>
      {{ $t('SHOP.COMMON.LABEL.OMNIBUS_MISSING') }}
    </template>
  </div>
</template>
<style lang="scss">
  :root {
    --sf-omnibus-color-text: var(--color-default);
    --sf-omnibus-font-family: var(--font-family-sans);
    --sf-omnibus-font-size: 0.625rem;
    --sf-omnibus-font-weight: var(--font-weight-regular);
    --sf-omnibus-padding-y: 0;
    --sf-omnibus-padding-x: 0;
    --sf-omnibus-margin-y: 0;
    --sf-omnibus-margin-x: 0;
  }

  .omnibus {
    font-size: var(--sf-omnibus-font-size);
    font-family: var(--sf-omnibus-font-family);
    color: var(--sf-omnibus-color-text);
    font-weight: var(--sf-omnibus-font-weight);
    padding: var(--sf-omnibus-padding-y) var(--sf-omnibus-padding-x);
    margin: var(--sf-omnibus-margin-y) var(--sf-omnibus-margin-x);
    text-wrap: balance;
  }
</style>
